import { Component, inject } from '@angular/core'
import { SystemConfigService } from '@account/Services/SystemConfigService'
import { PermissionsService } from '@account/Services/PermissionsService'
import { NavigationEnd, Router, RouterLink } from '@angular/router'
import { AccountService } from '@account/Services/AccountService'
import { CartService } from '@account/Services/CartService'
import { NgStyle } from '@angular/common'
import { MatBadge } from '@angular/material/badge'
import { MatIcon } from '@angular/material/icon'

@Component({
	selector: 'nav-component',
	templateUrl: './Nav.Component.html',
	imports: [RouterLink, NgStyle, MatIcon, MatBadge, MatBadge],
})
export class NavComponent {
	public activeRoute: string

	public systemConfigService: SystemConfigService

	public permissionsService: PermissionsService

	public cartService: CartService

	private readonly accountService: AccountService

	constructor() {
		this.systemConfigService = inject(SystemConfigService)
		this.permissionsService = inject(PermissionsService)
		this.cartService = inject(CartService)
		this.accountService = inject(AccountService)

		const router = inject(Router)

		router.events.subscribe((event) => {
			if (event instanceof NavigationEnd) {
				const split = event.url.split('/')
				this.activeRoute = split[1]
			}
		})
	}

	public logout = async (): Promise<void> => {
		window.localStorage.clear()

		await this.accountService.logout()

		window.location.reload()
	}
}
